/*
  assets/hrc-diagnostic-integrations.js
  Analitica (Prompt Maestro seccion 18) + captura de lead (seccion 15).

  Klaviyo: NO se define aqui ninguna clave ni ID de lista para el envio del
  informe -- no se ha proporcionado ninguno en el encargo (mismo estado que
  sections/hrc-lead-magnet.liquid, que ya tiene "[PENDIENTE DE DEFINIR]" para
  su propio Klaviyo). El envio del lead queda en modo prueba (console.log +
  cola local) hasta que se configure `klaviyo_list_id` en los ajustes de la
  seccion. El fallo o ausencia de esa integracion NUNCA bloquea el informe
  (regla 6 del documento).

  Los CTA de "Proximamente"/lista de espera de producto SI reutilizan el
  listener global ya existente (assets/hrc-klaviyo-waitlist.js) via el
  atributo data-hrc-klaviyo-form-id -- no se registra un segundo listener
  (regla 9 del documento).
*/
(function () {
  'use strict';

  var CFG = window.HRC_DIAGNOSTIC_CONFIG;
  var QUEUE_KEY = 'hrc_diagnostic_v1_pending_leads';

  function track(eventName, detail) {
    if (CFG.analyticsEvents.indexOf(eventName) === -1) return;
    try {
      if (window.gtag) window.gtag('event', eventName, detail || {});
      document.dispatchEvent(new CustomEvent(eventName, { detail: detail || {} }));
    } catch (e) {}
  }

  function readQueue() {
    try { return JSON.parse(window.localStorage.getItem(QUEUE_KEY) || '[]'); } catch (e) { return []; }
  }
  function writeQueue(list) {
    try { window.localStorage.setItem(QUEUE_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function queueLead(payload) {
    var queue = readQueue();
    queue.push(payload);
    writeQueue(queue);
  }

  // Intenta enviar los leads pendientes (p.ej. si hubo un fallo de red antes).
  // Nunca lanza: cualquier fallo se queda en la cola para el siguiente intento.
  function flushQueue(klaviyoListId) {
    if (!klaviyoListId) return;
    var queue = readQueue();
    if (!queue.length) return;
    var remaining = [];
    queue.forEach(function (payload) {
      try {
        // [PENDIENTE DE DEFINIR]: integracion real de captura de lead server-side.
        // Aqui solo se registra en consola (modo prueba), igual que
        // hrc-lead-magnet.liquid. No se expone ninguna clave privada.
        console.log('[HRC Diagnostico] Modo prueba - lead pendiente de envio a Klaviyo:', payload);
      } catch (e) {
        remaining.push(payload);
      }
    });
    writeQueue(remaining);
  }

  function submitLead(payload, klaviyoListId) {
    queueLead(payload);
    flushQueue(klaviyoListId);
    // El informe se muestra siempre, haya o no integracion configurada.
    return true;
  }

  window.HRC_DIAGNOSTIC_INTEGRATIONS = { track: track, submitLead: submitLead, flushQueue: flushQueue };
})();
